import React, { useEffect, useState } from "react";
import _, { flatten } from "lodash";
// eslint-disable-next-line
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import {
  fetchOrganizationFilters,
  updateGeneralFilters,
  clearGeneralFilters,
} from "../../../../../actions";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AutoCompleteField from "../../../../Forms/AutoCompleteField";
import {
  TextField,
  Chip,
  Grid,
  Box,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { sexOptions } from "../../../../../utils/const";
import ROUTES from "../../../../AppRouter/routes";
import {
  ArrowBack as ArrowBackIcon,
  ArrowDropDown as ArrowDropDownIcon,
} from "@mui/icons-material";
import TitleLayout from "./TitleLayout";

const DatePickerStyle = {
  width: "100%",
  "& .MuiInputLabel-root": {
    fontSize: [".7rem", ".7rem", ".7rem", ".7rem", ".7rem", ".7rem"],
    transform: {
      md: "matrix(1, 0, 0, 1, 0, 15)",
      lg: "matrix(1, 0, 0, 1, 0, 20)",
    },
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "12px",
  },
  "& .MuiInputLabel-shrink": {
    transform: {
      md: "matrix(0.75, 0, 0, 0.75, 0, -1.5)",
    },
  },
  "& .MuiInput-root": {
    mt: ["1rem", ".5rem", ".5rem", ".5rem", "1rem", "1rem"],
  },
  "& .MuiInput-input": {
    fontSize: ["1rem", ".66rem", ".66rem", ".66rem", "1rem", "1rem"],
  },
  "& .MuiInputAdornment-positionEnd": {
    mr: ["1rem", ".5rem", ".5rem", ".5rem", "1rem", "1rem"],
  },
  "& .MuiSvgIcon-root": {
    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
  },
};

const checkboxSx = {
  "& .MuiTypography-root": {
    fontSize: ["1rem", ".66rem", ".66rem", ".66rem", "1rem", "1rem"],
  },
  "& .MuiSvgIcon-root": {
    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
  },
};

const ReportFilter = ({
  generalFilters,
  updateGeneralFilters,
  clearGeneralFilters,
  options,
  isDropdownVisible,
  setIsDropdownVisible,
}) => {
  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const [areFiltersActive, setAreFiltersActive] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const buttonType = params.get("button");

  useEffect(() => {
    const excludedKeys = [
      "excludeAlgorithmUnsure",
      "excludeEmpty",
      "excludeUnknown",
      "algThreshold",
    ];

    const hasActiveFilters = Object.entries(generalFilters)
      .filter(([key]) => !excludedKeys.includes(key)) // Exclude specific keys
      .some(([key, value]) => {
        if (Array.isArray(value)) {
          return value.length > 0;
        } else if (value === null || value === "") {
          return false;
        } else if (typeof value === "boolean") {
          return value === true;
        } else if (typeof value === "number") {
          return value > 0;
        } else if (value instanceof Date) {
          // Check if the Date is valid and not equal to an empty date
          return !isNaN(value.getTime());
        }
        return false;
      });
    setAreFiltersActive(hasActiveFilters);
  }, [generalFilters]);

  const {
    algorithmGenusSpeciesOptions,
    contributedGenusSpeciesOptions,
    contributedPlatesOptions,
    trapTypesOptions,
    deviceOptions,
    trapSiteOptions,
    usersOptions,
    tagsOptions,
  } = options;

  const {
    deviceID,
    imagingStartDate,
    imagingEndDate,
    specimenCaptureStartDate,
    specimenCaptureEndDate,
    genusSpecies,
    plates,
    trapSitesFilter,
    trapTypesFilter,
    algorithmGenusSpeciesFilter,
    sexFilter,
    // eslint-disable-next-line no-unused-vars
    algorithmSexFilter,
    usersFilter,
    specimenTagFilter,
    excludeEmpty,
    excludeUnknown,
    // excludeAlgorithmUnsure,
  } = generalFilters;
  const setDeviceID = (val) => updateGeneralFilters({ deviceID: val });
  const setImagingStartDate = (val) =>
    updateGeneralFilters({ imagingStartDate: val });
  const setImagingEndDate = (val) => {
    if (Object.prototype.toString.call(val) === "[object Date]") {
      val.setHours(23);
      val.setMinutes(59);
      val.setSeconds(59);
    }
    updateGeneralFilters({ imagingEndDate: val });
  };
  const setSpecimenCaptureStartDate = (val) =>
    updateGeneralFilters({ specimenCaptureStartDate: val });
  const setSpecimenCaptureEndDate = (val) => {
    if (Object.prototype.toString.call(val) === "[object Date]") {
      val.setHours(23);
      val.setMinutes(59);
      val.setSeconds(59);
    }
    updateGeneralFilters({ specimenCaptureEndDate: val });
  };
  const setGenusSpecies = (val) => updateGeneralFilters({ genusSpecies: val });
  const setPlates = (val) => updateGeneralFilters({ plates: val });
  const setTrapSitesFilter = (val) =>
    updateGeneralFilters({ trapSitesFilter: val });
  const setTrapTypesFilter = (val) =>
    updateGeneralFilters({ trapTypesFilter: val });
  const setAlgorithmGenusSpeciesFilter = (val) =>
    updateGeneralFilters({ algorithmGenusSpeciesFilter: val });
  const setUsersFilter = (val) => updateGeneralFilters({ usersFilter: val });
  const setSexFilter = (val) => updateGeneralFilters({ sexFilter: val });
  // eslint-disable-next-line no-unused-vars
  const setAlgorithmSexFilter = (val) =>
    updateGeneralFilters({ algorithmSexFilter: val });
  const setSpecimenTagFilter = (val) =>
    updateGeneralFilters({ specimenTagFilter: val });
  const setExcludeEmpty = () =>
    updateGeneralFilters({ excludeEmpty: !excludeEmpty });
  const setExcludeUnknown = () =>
    updateGeneralFilters({ excludeUnknown: !excludeUnknown });
  // const setExcludeAlgorithmUnsure = () =>
  //     updateGeneralFilters({ excludeAlgorithmUnsure: !excludeAlgorithmUnsure });

  const computeHelperText = (props, error, startDate, endDate) => {
    if (error) {
      if (startDate > endDate) {
        if (props?.label === "Start Datetime")
          return "Date should not be after maximal date";
        else return "Date should not be before minimal date";
      }
      if (props?.inputProps?.value?.length === "mm/dd/yyyy hh:mm".length) {
        return "Invalid Date Format";
      } else {
        return "mm/dd/yyyy hh:mm";
      }
    }
    return "";
  };
  const history = useHistory();

  const handleGoBack = () => {
    history.push(ROUTES.dataTab);
  };

  return (
    <div className="flex-auto" aria-label="reports-filters-section">
      <div
        style={{
          display: "flex",
          marginTop: "30px",
          flexDirection: "column",
          color: "#167bc3",
          fontFamily: "Roboto",
          maxWidth: "100vw",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
            marginBottom: "10px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ marginLeft: "30px" }}>
            <Button onClick={handleGoBack} style={{ cursor: "pointer" }}>
              <ArrowBackIcon fontSize="medium" />
            </Button>
          </div>
          <TitleLayout buttonType={buttonType} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px",
            marginLeft: "50px",
            marginTop: "20px",
          }}
        >
          {/* Imaging Date selection */}
          <div style={{ flexBasis: "35%", margin: "auto" }}>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "500",
                marginBottom: "5px",
              }}
            >
              IMAGING DATE:
            </div>
            <Grid container spacing={3}>
              <Grid size={{ md: 5, lg: 5 }}>
                <DatePicker
                  autoOk
                  style={{ maxWidth: "4rem" }}
                  slotProps={{ textField: { size: "small" } }}
                  ampm={true}
                  value={imagingStartDate}
                  onChange={setImagingStartDate}
                  inputFormat="MM/dd/yyyy"
                  label="Start Date"
                  mask="__/__/____"
                  maxDate={imagingEndDate}
                  showToolbar
                  renderInput={(props) => (
                    <TextField
                      data-testid="Imaging Start Date"
                      label="Start Date"
                      variant="standard"
                      {...props}
                      helperText={computeHelperText(
                        props,
                        props.error,
                        imagingStartDate,
                        imagingEndDate
                      )}
                      style={{ paddingRight: 10 }}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ md: 5, lg: 5 }}>
                <DatePicker
                  style={{ maxWidth: "4rem" }}
                  slotProps={{ textField: { size: "small" } }}
                  label="End Date"
                  value={imagingEndDate}
                  onChange={setImagingEndDate}
                  inputFormat="MM/dd/yyyy"
                  mask="__/__/____"
                  minDate={imagingStartDate}
                  showToolbar={true}
                  renderInput={(props) => (
                    <TextField
                      data-testid="Imaging End Date"
                      label="End Date"
                      variant="standard"
                      sx={DatePickerStyle}
                      {...props}
                      helperText={computeHelperText(
                        props,
                        props.error,
                        imagingStartDate,
                        imagingEndDate
                      )}
                      style={{ paddingRight: 10 }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </div>
          <div style={{ flexBasis: "35%", margin: "auto" }}>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "500",
                marginBottom: "5px",
              }}
            >
              SPECIMEN CAPTURE DATE:
            </div>
            <Grid container spacing={3}>
              <Grid size={{ md: 5, lg: 5 }}>
                <DatePicker
                  autoOk
                  style={{ maxWidth: "4rem" }}
                  slotProps={{ textField: { size: "small" } }}
                  ampm={true}
                  value={specimenCaptureStartDate}
                  onChange={setSpecimenCaptureStartDate}
                  inputFormat="MM/dd/yyyy"
                  label="Start Date"
                  mask="__/__/____"
                  maxDate={specimenCaptureEndDate}
                  showToolbar
                  renderInput={(props) => (
                    <TextField
                      data-testid="Specimen Capture Start Date"
                      label="Start Date"
                      variant="standard"
                      sx={DatePickerStyle}
                      {...props}
                      helperText={computeHelperText(
                        props,
                        props.error,
                        specimenCaptureStartDate,
                        specimenCaptureEndDate
                      )}
                      style={{ paddingRight: 10 }}
                    />
                  )}
                />
              </Grid>
              <Grid size={{ md: 5, lg: 5 }}>
                <DatePicker
                  style={{ maxWidth: "10rem" }}
                  slotProps={{ textField: { size: "small" } }}
                  label="End Date"
                  value={specimenCaptureEndDate}
                  onChange={setSpecimenCaptureEndDate}
                  inputFormat="MM/dd/yyyy"
                  mask="__/__/____"
                  minDate={specimenCaptureStartDate}
                  showToolbar={true}
                  renderInput={(props) => (
                    <TextField
                      data-testid="Specimen Capture End Date"
                      label="End Date"
                      variant="standard"
                      sx={DatePickerStyle}
                      {...props}
                      helperText={computeHelperText(
                        props,
                        props.error,
                        specimenCaptureStartDate,
                        specimenCaptureEndDate
                      )}
                      style={{ paddingRight: 10 }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </div>
          <div style={{ flexBasis: "30%", justifyContent: "flex-start" }}>
            {/* Reset button  */}
            <Box
              className={"flex"}
              sx={{
                mt: ["1.5rem", "1.5rem", ".75rem", "1.5rem", "1.5rem"],
              }}
            >
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  clearGeneralFilters();
                }}
                id={"reset-data-download-filters"}
                color={"primary"}
                variant={"outlined"}
                size={"small"}
                sx={{ marginRight: "5px" }}
                disabled={!areFiltersActive}
              >
                <div style={{ fontSize: "12px", padding: "0 8px" }}>Reset</div>
              </Button>

              <Button
                onClick={toggleDropdown} // Handle the dropdown toggle
                id={"toggle-filters-dropdown"}
                color={"primary"}
                variant={"outlined"}
                size={"small"}
              >
                <span style={{ fontSize: "12px", padding: "0 10px" }}>
                  {isDropdownVisible ? "HIDE FILTERS" : "SHOW FILTERS"}
                </span>
                <ArrowDropDownIcon
                  style={{
                    cursor: "pointer",
                    transform: isDropdownVisible
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    fontSize: "20px",
                  }}
                />
              </Button>
            </Box>
          </div>
        </div>

        {isDropdownVisible && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                flexBasis: "85%",
                marginLeft: "50px",
                display: "flex",
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }}
            >
              <AutoCompleteField
                label={"Device"}
                disableCloseOnSelect
                value={deviceID}
                onChange={(e, newValue) => {
                  setDeviceID(newValue);
                }}
                // onChange={handleDeviceIDChange}
                getOptionLabel={(option) => option?.displayName}
                multiple
                options={deviceOptions}
                isOptionEqualToValue={(option, value) => {
                  return option.id === value.id;
                }}
                style={{ flexBasis: "20%", padding: "5px" }}
              />
              <AutoCompleteField
                label={"Contributed Species"}
                value={genusSpecies}
                disableCloseOnSelect
                onChange={(e, newValue) => {
                  setGenusSpecies(newValue);
                }}
                getOptionLabel={(option) =>
                  `${option.name?.genus} ${option.name?.species}`
                }
                multiple
                options={contributedGenusSpeciesOptions}
                style={{ flexBasis: "20%", padding: "5px" }}
              />
              <AutoCompleteField
                label={"Algorithm Species"}
                value={algorithmGenusSpeciesFilter}
                disableCloseOnSelect
                onChange={(e, newValue) => {
                  setAlgorithmGenusSpeciesFilter(newValue);
                }}
                getOptionLabel={(option) =>
                  `${option?.name?.genus} ${option?.name?.species}`
                }
                multiple
                options={algorithmGenusSpeciesOptions}
                style={{ flexBasis: "20%", padding: "5px" }}
              />

              <AutoCompleteField
                label={"Plates"}
                value={plates}
                disableCloseOnSelect
                onChange={(e, newValue) => {
                  setPlates(newValue);
                }}
                getOptionLabel={(option) => option}
                multiple
                options={contributedPlatesOptions}
                style={{ flexBasis: "20%", padding: "5px" }}
              />
              <AutoCompleteField
                label={"Contributed Sex"}
                disableCloseOnSelect
                value={sexFilter}
                onChange={(e, newValue) => {
                  setSexFilter(newValue);
                }}
                getOptionLabel={(option) => option}
                multiple
                options={sexOptions}
                style={{ flexBasis: "20%", padding: "5px" }}
              />
              <AutoCompleteField
                label={"Specimens and Tray Tag"}
                value={specimenTagFilter}
                disableCloseOnSelect
                onChange={(e, newValue) => {
                  setSpecimenTagFilter(newValue);
                }}
                getOptionLabel={(option) => option}
                multiple
                freeSolo
                options={tagsOptions}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="filled"
                    label="freeSolo"
                    placeholder="Favorites"
                  />
                )}
                style={{ flexBasis: "20%", padding: "5px" }}
              />

              <AutoCompleteField
                label={"Collection Sites"}
                disableCloseOnSelect
                value={trapSitesFilter}
                onChange={(e, newValue) => {
                  setTrapSitesFilter(newValue);
                }}
                getOptionLabel={(option) => option?.displayName}
                multiple
                options={trapSiteOptions}
                style={{ flexBasis: "20%", padding: "5px" }}
              />
              <AutoCompleteField
                label={"Collection Methods"}
                value={trapTypesFilter}
                disableCloseOnSelect
                onChange={(e, newValue) => {
                  setTrapTypesFilter(newValue);
                }}
                getOptionLabel={(option) => option?.displayName}
                multiple
                options={trapTypesOptions}
                style={{ flexBasis: "20%", padding: "5px" }}
              />
              <AutoCompleteField
                label={"Users"}
                value={usersFilter}
                disableCloseOnSelect
                onChange={(e, newValue) => {
                  setUsersFilter(newValue);
                }}
                getOptionLabel={(option) => option}
                multiple
                options={usersOptions}
                style={{ flexBasis: "20%", padding: "5px" }}
              />
            </div>
            {/* Checkbox selection  */}
            <div style={{ flexBasis: "15%", marginLeft: "10px" }}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  <div style={{ color: "#167bc3", marginTop: "20px" }}>
                    EXCLUDE
                  </div>
                </FormLabel>
                <FormGroup>
                  <FormControlLabel
                    checked={excludeEmpty}
                    value="empty"
                    control={<Checkbox />}
                    label="EMPTY"
                    sx={checkboxSx}
                    onClick={() => setExcludeEmpty()}
                  />
                  <FormControlLabel
                    checked={excludeUnknown}
                    value="unknown"
                    control={<Checkbox />}
                    label="UNKNOWN"
                    sx={checkboxSx}
                    onClick={() => setExcludeUnknown()}
                  />
                </FormGroup>
              </FormControl>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { selectedDevice, ...devices } = state.devices;
  const { count, ...trapSites } = state.trapSites;
  const {
    contributedGenusSpecies = [],
    plateWells = {},
    algorithmGenusSpecies = [],
    users = [],
    tags: tagsOptions = [],
  } = state.organization;
  const contributedPlates = Object.keys(
    _.pickBy(plateWells, (plate, wells) => wells.length > 0)
  );
  const { timeZone } = state.user;

  const curDevices = Object.values(
    _.pickBy(
      devices,
      (value, _) => value?.env === process.env.REACT_APP_ENV.toUpperCase()
    )
  );

  //get all tags from the current trays
  let tagsAll = Object.values(state?.devices)?.reduce((accumulator, cur) => {
    if (cur?.trays) {
      let res = Object.values(cur?.trays)?.reduce((acc, curTray) => {
        if (curTray?.tags) {
          return [...acc, curTray?.tags];
        }
        return acc;
      }, []);
      return [...accumulator, ...res];
    }
    return accumulator;
  }, []);

  const options = {
    deviceOptions: curDevices,
    trapSiteOptions: Object.values(trapSites),
    contributedGenusSpeciesOptions: contributedGenusSpecies,
    contributedPlatesOptions: contributedPlates,
    algorithmGenusSpeciesOptions: algorithmGenusSpecies,
    usersOptions: users,
    trapTypesOptions: Object.values(state.collectionMethods),
    tagsOptions: Array.from(new Set([...flatten(tagsAll), ...tagsOptions])),
  };

  const defaultAlgorithmConfidenceThreshold =
    state.organization?.["defaultAlgorithmConfidenceThreshold"]?.["mosquito"];

  return {
    devices: curDevices,
    options,
    selectedDevice,
    timeZone,
    generalFilters: {
      ...state.data.generalFilters,
      algThreshold: state.user.algConfidence
        ? state.user.algConfidence
        : defaultAlgorithmConfidenceThreshold,
    },
  };
};

export default connect(
  mapStateToProps,
  // mapDispatchToProps,
  {
    fetchOrganizationFilters,
    updateGeneralFilters,
    clearGeneralFilters,
  }
)(ReportFilter);
